import { BaseReactComponent } from "@/Common/Components/BaseReactComponent";
import { StatusComponent } from "@/Common/Components/Patient/StatusComponent";
import { Patient } from "@/Common/Models/Patient/Patient";
import { OntarioPatientEnrollmentModel } from "@/Common/Models/Patient/PatientEnrollment/Ontario/OntarioPatientEnrollmentModel";
import { OntarioEnrollmentHelper } from "./OntarioEnrollmentHelper";

import img_icon_bluestart from "@/Common/_images/Icons/Ramq/BlueStart.png";

interface IOntarioPatientBannerEnrollmentProps {
    patient: Patient;
    ontarioPatientEnrollmentModel: OntarioPatientEnrollmentModel;
    onOntarioEnrollmentClick?: () => void;
}

class OntarioPatientBannerEnrollmentState {
    public ontarioEnrollment: OntarioPatientEnrollmentModel = null;

    public constructor(fields?: Partial<OntarioPatientBannerEnrollmentState>) {
        Object.assign(this, fields);
    }
}

class OntarioPatientBannerEnrollment extends BaseReactComponent<IOntarioPatientBannerEnrollmentProps, OntarioPatientBannerEnrollmentState> {
    private ontarioEnrollmentHelper: OntarioEnrollmentHelper;

    constructor(props: IOntarioPatientBannerEnrollmentProps) {
        super(props);

        this.state = this.createInitialState(props);
        this.ontarioEnrollmentHelper = new OntarioEnrollmentHelper(props.patient, props.ontarioPatientEnrollmentModel);
    }

    public componentDidUpdate(prevProps: IOntarioPatientBannerEnrollmentProps): void {
        if (this.props.ontarioPatientEnrollmentModel !== prevProps.ontarioPatientEnrollmentModel
            || this.props.patient !== prevProps.patient
        ) {
            this.setState(this.createInitialState(this.props));
            this.ontarioEnrollmentHelper = new OntarioEnrollmentHelper(this.props.patient, this.props.ontarioPatientEnrollmentModel);
        }
    }

    private createInitialState(props: IOntarioPatientBannerEnrollmentProps): OntarioPatientBannerEnrollmentState {
        return new OntarioPatientBannerEnrollmentState({
            ontarioEnrollment: props.ontarioPatientEnrollmentModel
        });
    }

    public render(): JSX.Element {
        const primaryPhysician = this.ontarioEnrollmentHelper.getPrimaryPhysician();
        const enrollmentStatus = this.ontarioEnrollmentHelper.getPhysicianStatus();
        const enrollmentStatusInfo = this.ontarioEnrollmentHelper.getPhysicianStatusInfo(enrollmentStatus);

        return (
            <>
                {!IsNullOrWhiteSpace(primaryPhysician) && (
                    <div
                        className="flex-container flex-start align-bottom"
                    >
                        <img className="margin-xs-left" style={{ width: "12px" }} src={img_icon_bluestart} alt="blue-star" />
                        <span className="margin-xs-left">
                            {primaryPhysician}
                        </span>
                    </div>
                )}
                <StatusComponent
                    status={enrollmentStatus}
                    onClickStatus={() => this.props.onOntarioEnrollmentClick?.()}
                    statusInfo={enrollmentStatusInfo}
                />
            </>
        );
    }
}

export { OntarioPatientBannerEnrollment };
